package com.bikompanion.ui.home

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.DpOffset
import dev.chrisbanes.haze.HazeState
import dev.chrisbanes.haze.hazeSource
import org.maplibre.compose.interaction.ClickResult
import org.maplibre.compose.map.MapState
import com.bikompanion.domain.BikeNetwork
import com.bikompanion.domain.BikeParkingSpot
import com.bikompanion.domain.BikeStation
import com.bikompanion.ui.composables.MapLayer
import com.bikompanion.ui.composables.MapMarkersOverlay
import com.bikompanion.ui.models.ParkingAreaSummary
import kotlin.time.ComparableTimeMark

@Composable
internal fun HomeMapArea(
    cameraState: MapState,
    darkTheme: Boolean,
    hazeState: HazeState,
    onStationTap: (DpOffset) -> ClickResult,
    onCompassClick: () -> Unit,
    networks: List<BikeNetwork>,
    stations: List<BikeStation>,
    parkingSpots: List<BikeParkingSpot>,
    parkingAreas: List<ParkingAreaSummary>,
    changedAt: Map<String, ComparableTimeMark>,
    markerScale: () -> Float,
) {
    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(MaterialTheme.colorScheme.background)
            .hazeSource(hazeState),
    ) {
        MapLayer(
            mapState = cameraState,
            darkTheme = darkTheme,
            onStationTap = onStationTap,
            onCompassClick = onCompassClick,
        )

        MapMarkersOverlay(
            cameraState = cameraState,
            networks = networks,
            stations = stations,
            parkingSpots = parkingSpots,
            parkingAreas = parkingAreas,
            changedAt = changedAt,
            modifier = Modifier.fillMaxSize(),
            markerScale = markerScale,
        )
    }
}
